import axios from '@/api/config';

const agentGoods = {
  getGoodsInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/agentGoods/getGoodsInfo/` + data, {});
  },
  goodsMarketPageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentGoods/goodsMarketPageList`, data);
  },
}

export default agentGoods;



// WEBPACK FOOTER //
// ./src/api/agentGoods.js